module.exports = __webpack_public_path__ + "static/media/vas_nocam.94b13b6a.svg";